const getSimulatorSteps = state => {
  return state.simulatorSteps.steps;
}

const getCurrentStep = state => {
  return state.simulatorSteps.currentStep;
}

const getValidatedSteps = state => {
  return state.simulatorSteps.validatedSteps;
}

const getDwellingForm = state => {
    return state.dwelling_tunnel_form;
};

const getDwellingStepAnswers = state => {
  return state.answers_dwelling_step;
}

const getLeadFormAnswers = state => {
  return state.answers_lead_form;
}

const getDwellingStepResume = state => {
  return state.dwelling_step_resume;
}

const getLeadConfig = state => {
  return state.lead_config;
}

const getAidsForm = state => {
  return state.aids_tunnel_form;
};

const getAidsStepAnswers = state => {
  return state.answers_aids_step;
};

const getSavingOptionsAnswers = state => {
  return state.answers_saving_options;
};

const getPreviousQuestion = state => {
  return state.previousQuestion;
}

const getMcpDpe = state => {
  return state.mcp_dpe;
}

const getSimulatorPathInfos = state => {
  return state.simulator_path_infos;
}

const getGtmEventsDatas = state => {
  return state.gtm_events_datas;
}

export default {
    getDwellingForm,
    getDwellingStepAnswers,
    getLeadFormAnswers,
    getDwellingStepResume,
    getLeadConfig,
    getSimulatorSteps,
    getCurrentStep,
    getValidatedSteps,
    getAidsForm,
    getAidsStepAnswers,
    getSavingOptionsAnswers,
    getPreviousQuestion,
    getMcpDpe,
    getSimulatorPathInfos,
    getGtmEventsDatas
};
